/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Billing_SaveInputs */



/**
* | output |
* | --- |
* | "2 months free" |
*
* @param {Signup_Billing_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_billing_save = /** @type {((inputs?: Signup_Billing_SaveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Billing_SaveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("2 mois offerts")
	if (locale === "de") return /** @type {LocalizedString} */ ("2 Monate gratis")
	if (locale === "it") return /** @type {LocalizedString} */ ("2 mesi gratis")
	if (locale === "ru") return /** @type {LocalizedString} */ ("2 месяца бесплатно")
	if (locale === "es") return /** @type {LocalizedString} */ ("2 meses gratis")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("免费 2 个月")
	if (locale === "ja") return /** @type {LocalizedString} */ ("2か月分無料")
	if (locale === "hi") return /** @type {LocalizedString} */ ("2 महीने मुफ़्त")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("2 meses grátis")
	return /** @type {LocalizedString} */ ("2 months free")
});